module.exports = __webpack_public_path__ + "static/console.72e0a8b3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/blog/2018/typescript-babel/console.gif
// module id = 601
// module chunks = 215142963678715